import React, { useState, useContext, useCallback, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { message, Tooltip } from "antd";
import context, { useTranslation } from "../../context";
import CardList from "../../components/CardList";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { getShortcuts, shortcutRemove } from "../../api";
import {
  createJoyspcFolderData,
  createPageUrl,
  getFilePath,
  getFullPathByForomId,
  handleLoadMore,
  notUseJoySpaceOffline
} from "../../util";
import openDeleteModal from "../../contextModal/DeleteModal";
import events from "../../context/events";
import { isBjme } from "@/utils";
import { ActionFnEnum, ActionType, ContextMenuMode, FileType, MenusType } from "../../types";
// import { createPageUrl } from "../../components/PageLink";
import { analysisLog } from "@/utils/logAnalytics";
import ShortcutPopover from "./Popover";
import "./index.less";
import IconFont from "@/components/icon";
import UpdataService, { getFileInfo } from "../../reloadUtils";
import { folderTypeEnum, joyspacePermissionType } from "../../config/permissions.config";
import { addJoysapceMap } from "../../api/permissions";
import { useNavigator } from "@/utils/NetworkCheck";
import { useListData } from "../../components/TableList/Use/useListData";
import JoyspaceController from "../../controllers/JoyspaceController";
const PartialUpdata = Object.create(UpdataService);
const key = MenusType.SHORTCUT;
export default function () {
  const lang = useTranslation();
  const [shortcuts, setShortcuts] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isLoadMore, setLoadMore] = useState<boolean>(false);
  const { appRuntimeEnv, focusSDK, onLine } = useContext<GlobalContextConfig>(GlobalContext);
  const { addFolderInfo } = useContext(context);
  const history = useHistory();
  const [disabled, setDisabled] = React.useState(false);
  const urlPrefix = appRuntimeEnv.joyspaceHost;
  const getShortcutLists = () => {
    return new Promise<any>((resolve, reject) => {
      getShortcuts(0, 99, addFolderInfo)
        .then(async (result: any) => {
          const { data, total } = result;
          let pages;
          if (!useNavigator.onLine) {
            pages = await JoyspaceController?.setOffLineList(data);
          } else {
            pages = data;
          }
          resolve({
            pages,
            total
          });
          if (total > 9) {
            setLoadMore(true);
          } else {
            setLoadMore(false);
          }
        })
        .finally(() => { })
        .catch((err) => {
          reject(err.message);
          err.message && message.error(err.message);
        });
    });
  };
  const { list, loading: listLoading } = useListData({
    key,
    isFilter: false,
    isCategory: false,
    requestPagesFunc: getShortcutLists
  });
  useEffect(() => {
    if (list.length <= 0) {
      setShortcuts([]);
      return;
    }
    setLoading(false);
    if (isLoadMore) {
      setShortcuts(list.slice(0, 9));
      return;
    }
    setShortcuts([...list]);
  }, [list, isLoadMore]);

  useEffect(() => {
    const handleChange = () => {
      events.emit("list.syncReload", {
        key
      });
    };
    events.on("shortcut.change", handleChange);
    return () => {
      events.off("shortcut.change", handleChange);
    };
  }, []);
  const deleteNOne = useCallback(
    (newItem: any) => {
      shortcutRemove(newItem.id, newItem.type)
        .then((data: boolean | null) => {
          if (data) {
            console.log();
            message.success(isBjme() ? "已从置顶中移除" : lang("removed-from-quick-access"));
            // 删除自己
            events.emit("list.partial.refresh", {
              key: MenusType.SHORTCUT,
              changeData: { id: newItem.id, actionType: ActionType.Page, type: ActionFnEnum.REMOVE }
            });
            // 刷新别的列表
            events.emit("list.partial.refresh", {
              changeData: {
                newItem: { id: newItem.id, isShortcuted: false },
                id: newItem.id,
                actionType:
                  typeof newItem.pageType === "undefined" ? ActionType.Folder : ActionType.Page,
                type: ActionFnEnum.UPDATE
              }
            });
          }
        })
        .catch(() => {
          message.error(lang("network-anomaly"));
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [shortcuts]
  );

  const openLink = useCallback(
    (url: string, target: string) => {
      focusSDK.printLog("joyspace: 打开置顶文档 before：", url);
      try {
        window.open(url, target);
      } catch (e) {
        focusSDK.printLog("joyspace: 打开置顶文档 error：", e);
      }
      focusSDK.printLog("joyspace: 打开置顶文档 end：", url);
    },
    [focusSDK]
  );
  const openFile = useCallback(
    async (e, item: any) => {
      if (!item.status && useNavigator.onLine) {
        openDeleteModal(item.isFolder ? FileType.Folder : FileType.Page, item.id, "shortcuts");
        return;
      }
      if (item.isFolder) {
        // // 我的文件跳转
        // if (!item.spaceId) {
        //   history.push(item.path);
        //   return;
        // }
        history.push(item.path);
        // const res: any = await addJoysapceMap(item.spaceId, item, addFolderInfo);
        // const path =
        //   res !== joyspacePermissionType.ReadDel ? getFilePath(res.type, item.spaceId) : item.path;
        // history.push(path);
        return;
      }
      analysisLog(
        "tbg_jzb_joyspace_home_1676548210761",
        "35",
        item.isFolder ? "folder" : item?.pageType,
        item?.id
      );
      item.page_type = item.pageType;
      openLink(createPageUrl(item, urlPrefix), "_blank");
    },
    [history, openLink, urlPrefix]
  );
  const openFolder = useCallback(
    async (e: any, item: any) => {
      e.stopPropagation();
      // const folderId = item.pageType ? item.spaceId : item.id;
      let path = item.path;
      if (item.type === 4) {
        // 文件夹
        const fullPaths = item.fullPath.split("$@$");
        let parentPath = "";
        if (fullPaths.length > 1) {
          parentPath = fullPaths.slice(0, -1).join("$@$");
        }
        path = getFilePath(item.folderType, getFullPathByForomId(parentPath));
      }
      history.push(path);
      //   try {
      //     const res: any = await addJoysapceMap(folderId, item, addFolderInfo);
      //     const path =
      //       res !== joyspacePermissionType.ReadDel ? getFilePath(res.type, folderId) : item.path;
      //     history.push(path);
      //   } catch (error) {
      //     history.push(item.path);
      //   }
    },
    [history]
  );
  const onButtom = useCallback(() => {
    if (isLoadMore) {
      setLoadMore(false);
    }
  }, [isLoadMore]);
  const className = useMemo(() => {
    let name = "joyspace-list-text joyspace-list-ellipsis joyspace-card-desc";
    if (!onLine) {
      return `${name} joyspace-card-desc-offline`;
    }
    return name;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);

  const getPathName = (item: any) => {
    if (!item) {
      return;
    }
    if (item.kl_type) {
      return "知识库：" + item.space_name;
    }
    if (item.pageType) {
      // 文件
      return item.pathName;
    } else {
      // 文件夹
      const pathNames = item.pathName.split("/");
      if (pathNames.length > 1) {
        return pathNames.slice(0, -1).join("/");
      } else {
        return item.pathName;
      }
    }
  };

  return (
    <CardList
      title="置顶"
      list={shortcuts}
      loading={loading}
      isLoadMore={isLoadMore}
      callback={openFile}
      onButtom={onButtom}
      allowDraggble={false}
      // emptyText="暂无文件夹，点击“新建”创建文件夹"
      renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
        if (!item.id) {
          return <span />;
        }
        return (
          <ShortcutPopover
            contextMenuMode={contextMenuMode}
            isFolder={item.isFolder}
            popoverDisabled={!onLine && !item.isDBExist}
            offlineDisabled={!onLine}
            isShortcut={item.isShortcut}
            callback={(action: string) => {
              if (action === "edit") {
                openFile(undefined, item);
                return;
              }
              if (disabled) {
                return;
              }
              deleteNOne(item);
            }}
          />
        );
      }}
      renderDesc={(item: any) => {
        if (item.isSpace) {
          return (
            <div className="shortcut-fixed-icon">
              <span className={className}>{item.description || "固定"}</span>
              <IconFont type="iconpc_ic_guding_doc" />
            </div>
          );
        }
        return (
          <span
            className={
              item.pathName === "/"
                ? `${className} joyspace-card-desc-disable`
                : `${className} joyspace-card-desc-hover`
            }
            onClick={(e) => {
              e.stopPropagation();
              if (item.kl_type) { // 知识库
                return;
              }
              if (item.pathName === "/") {
                return;
              }
              openFolder?.(e, item);
            }}
          >
            {getPathName(item)}
          </span>
        );
      }}
    />
  );
}
